import { useMemo } from 'react';

import type { HTTPHeaders } from '@rtkwlf/rendall';
import { Configuration, DefaultApi } from '@rtkwlf/rendall';

import { useAuthContext } from '@packages/legacy/auth';
import { useOrganizationContext } from '@packages/legacy/organization-context';

export const useRendallApi = (headers?: HTTPHeaders): DefaultApi => {
  const { fetchApi } = useAuthContext();

  const { selectedOrganization } = useOrganizationContext();

  return useMemo(
    () =>
      new DefaultApi(
        new Configuration({
          basePath: selectedOrganization.rendallURL,
          fetchApi,
          headers,
        }),
      ),
    [fetchApi, headers, selectedOrganization.rendallURL],
  );
};
